module.exports = "<button (click)=\"CreateHeatMap()\">CreateHeatMap</button>\n\n<div class=\"mouseOverContent\" style=\"opacity:0\"></div>\n<div style=\"margin:10px 10px\" id=\"celldetails\">\n    <textarea cols=\"90\" rows=\"5\" id=\"cellpara\">    </textarea>    \n</div>\n\n<div style=\"margin:10px 10px;\" id=\"heatmap\">\n\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/jvutukur/Downloads/HeatMap/ng-heatmap/ng-heatmap/src/app/components/heat-map/heat-map.component.html
// module id = ../../../../../src/app/components/heat-map/heat-map.component.html
// module chunks = main